/**
 * Throttled scroll handler to prevent excessive reflows
 */
export const createThrottledScrollHandler = (callback: () => void) => {
  let ticking = false;

  return () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        callback();
        ticking = false;
      });
      ticking = true;
    }
  };
};
